import { ErrorDialogService } from './errorDialogService';
import { NgModule } from '@angular/core';
import { ErrorDialog } from './errorDialog';
import { AppMaterialModule } from '../appMaterial/app-material.module';

@NgModule({
    imports: [AppMaterialModule],
    exports: [ErrorDialog],
    declarations: [ErrorDialog],
    providers: [ErrorDialogService]
})
export class ErrorDialogModule {}
